/* [[ AUTO GENERATED - DO NOT MODIFY ]] */

export const IntegrationState = {
    Enabled: 'enabled',
    Disabled: 'disabled',
    MissingConfig: 'missing_config'
};
